// addSuccessorHook.ts
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type AddSuccessorType = {
  fullName: string;
  nationalId: string;
  phone: string;
  email: string;
  address: string;
  postalCode: string;
  city: string;
  country: string;
  phonePrefix?: string;
};

export const useAddSuccessor = (
  options?: UseMutationOptions<any, Error, AddSuccessorType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["addSuccessor"],
    mutationFn: async (payload: AddSuccessorType) => {
      return axiosInstance
        .post("/successors", payload)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Przetwarzanie żądania dodania sukcesora...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "add-successor",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Sukcesor dodany pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "add-successor",
      });
      queryClient.invalidateQueries({ queryKey: ["successors-list"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      if (options && options.onError) {
        options.onError(error, variables, context);
      }

      if (error?.data?.message === "User with this email already exists") {
        Toast({
          message: "Sukcesor z tym adresem e-mail już istnieje.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "add-successor",
        });
      }

      Toast({
        message: "Błąd podczas dodawania sukcesora.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "add-successor",
      });
    },
  });
};

export default useAddSuccessor;
